<template>
  <div id="contacts">
      <v-container>

        <span v-if="language === 'RU'"><PageTitle :title="title_RU"  class="mt-4" /></span>
        <span v-if="language === 'EN'"><PageTitle :title="title_EN"  class="mt-4" /></span>   

          <v-layout row wrap align-center justify-center fill-height class="mt-4">
              <v-flex xs12 sm6 class="br-dark"> 
                <v-card dark>
                  <v-card-title>
                    <span v-if="language === 'RU'">  {{ producer_RU }} &nbsp;<strong>  {{ Tuleyev_RU }} </strong></span> 
                    <span v-if="language === 'EN'">  {{ producer_EN }} &nbsp;<strong>  {{ Tuleyev_EN }} </strong></span>
                  </v-card-title>
                  <v-card-text>
                    <v-icon left class="white--text">phone</v-icon> +38.067.524.6253 <br>
                    <v-icon left class="white--text">email</v-icon> igor07 @ meta.ua
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6>
                <v-card dark>
                  <v-card-title>
                    <span v-if="language === 'RU'">{{ soundman_RU }}  &nbsp;<strong>  {{ Turchin_RU }} </strong></span>
                    <span v-if="language === 'EN'">{{ soundman_EN }}  &nbsp;<strong>  {{ Turchin_EN }} </strong></span>                    
                  </v-card-title>
                  <v-card-text> 
                    <v-icon left class="white--text">phone</v-icon> +38.050.620.2946 <br>
                    <v-icon left class="white--text">email</v-icon> turchinsound @ gmail.com 
                  </v-card-text>
                </v-card>
              </v-flex>
          </v-layout>        
      </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/PageTitle'
  export default {
    name: 'Contacts',
    components: { PageTitle },
    data() {
      return {
        language: '',
        title_RU: 'Контакты',
        title_EN: 'Contacts',

        producer_RU: 'Продюсер ',
        producer_EN: 'Producer ',

        soundman_RU: 'Звукорежиссер ',
        soundman_EN: 'Soundman ',

        Tuleyev_RU: ' Игорь Тулеев',
        Tuleyev_EN: ' Igor Tuleev', 

        Turchin_RU: ' Александр Турчин',
        Turchin_EN: ' Alexander Turchin'
      }
    },
    created() {

      if(localStorage.lang){
        this.language = localStorage.lang
      }

      console.log('Язык такой: ', this.language)
    }
  }
</script>

<style>
  #contacts {
    font-size: 22px;
  }

</style>



